import * as React from 'react';
import * as styles from './Fact.css';
import { TFactType } from '../../types/developerV2/fact';
import {
  PictogramB2BSpeciality40,
  PictogramBuildingCommissioning40,
  PictogramBuildingBuilding40,
} from '@cian/ui-kit-design-tokens/pictograms';
import { Tooltip } from '@cian/ui-kit';
import { IconFunctionalInformationCircle16 } from '@cian/ui-kit-design-tokens/icons';

interface IFactProps {
  title: string;
  text: string;
  description?: string;
  type: TFactType;
}

export const Fact = ({ title, type, text, description }: IFactProps) => {
  const icon = React.useMemo(() => {
    switch (type) {
      case 'foundationYear':
        return <PictogramBuildingBuilding40 />;
      case 'inProgress':
        return <PictogramB2BSpeciality40 />;
      case 'completed':
      case 'onTime':
      default:
        return <PictogramBuildingCommissioning40 />;
    }
  }, [type]);

  return (
    <li className={styles['fact']}>
      <div className={styles['icon']}>{icon}</div>
      <div className={styles['description']}>
        <span className={styles['title']}>{title}</span>
        <span className={styles['text']}>
          {text}
          {description && (
            <span className={styles['info']}>
              <Tooltip theme="white" title={description}>
                <div className={styles['inner-info']}>
                  <IconFunctionalInformationCircle16 />
                </div>
              </Tooltip>
            </span>
          )}
        </span>
      </div>
    </li>
  );
};
